import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useMenu } from "hook/useMenu";
import { useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { useAppSelector } from "redux/hooks";

export default function UsageEntry(): JSX.Element {
  const [searchParams] = useSearchParams();
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const { buildEntryNavigateProps, updateCurrentAccount } = useMenu({});
  const accountId = searchParams.get("account") || searchParams.get("accountId");
  const isMyAccount = !!accountId && accountId === selectedAccount.accountId;

  useEffect(() => {
    if (!isMyAccount) {
      return;
    }
    updateCurrentAccount();
  }, [isMyAccount]);

  /**
   * ORG API 조회 후 /subscription/usage/plan 없으면 signup 으로
   * plan 있으면 /subscription/usage/organization 으로
   */
  if (!isMyAccount) {
    return <></>;
  }
  if (!selectedAccount.isUsagePaid) {
    return (
      <Navigate
        {...buildEntryNavigateProps("/subscription/usage/signup")}
        replace
      />
    );
  }

  return (
    <Navigate
      {...buildEntryNavigateProps("/subscription/usage/organization")}
      replace
    />
  );
}
